export default __webpack_public_path__ + "static/media/ic_tune.5989fef1.svg";